import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { CommonConstant } from '../constants';
import { environment } from '../environments/environment';
import { SetApiUrl } from '../store/app/app.action';

/** API URL Generator */
export const MS_API_DOMAIN = (subdomain: string) => {
  let env = '';
  if (environment.SENTRY_ENV !== CommonConstant.ENVIRONMENT.PRODUCTION) {
    if (environment.SENTRY_ENV === CommonConstant.ENVIRONMENT.STAGING) {
      env = CommonConstant.ENVIRONMENT.STAGING;
    } else if (environment.SENTRY_ENV === CommonConstant.ENVIRONMENT.DEV) {
      env = CommonConstant.ENVIRONMENT.DEV;
    }
  }
  //Use when deploying
  return environment.API_URL || `https://${subdomain}${env ? `.${env}` : ''}.touch.mealsuite.com`;
};

@Injectable({
  providedIn: 'root'
})
export class ConfigProvider {
  constructor(private store: Store) {}

  configHost(subdomain = CommonConstant.TENANT_TYPE.SYNERGY) {
    subdomain = subdomain.replace('.live', '');
    const apiUrl = this.apiURLFor(subdomain);
    this.store.dispatch(new SetApiUrl(apiUrl));
  }

  /** Get the api urls for the given provider */
  private apiURLFor(subdomain: string) {
    return MS_API_DOMAIN(subdomain);
  }
}
